import { types } from "./tower_towerobservationtype.actions";
import { Reducer } from "../../services/reducer.factory";

const initialState = {
  columns: [
    {
      field: "oid",
      header: "Código",
      columnKey: "oid",
      sortable: true,
      filter: true,
    },
    {
      field: "name",
      header: "Nome",
      columnKey: "name",
      sortable: true,
      filter: true,
    },

    {
      field: "eventRecord.createdAt",
      header: "Data de Cadastro",
      columnKey: "eventRecord.createdAt",
      sortable: true,
      filter: true,
    },
  ],
};

const reducer = new Reducer(initialState, types);

export function CRUDTowerObservationTypeReducer(state, action) {
  state = reducer.execute(state, action);
  return execute(state, action);
}

function execute(state, action) {
  let result = state;
  switch (action.type) {
    default:
      return result;
  }
}
